<app-banner [links]="bannerLinks"></app-banner>

<!-- Section navigation for small screens as text links, below bannerlinks -->
<div class="flex justify-center gap-4 mb-3 md:hidden text-sm font-semibold">
  <a [routerLink]="['/', selectedCountry?.code?.toLowerCase(), 'medecins']" [ngClass]="{
      'text-primary': currentSection === 'medecins',
      'text-gray-500': currentSection !== 'medecins'
    }">Professionnels</a>
  <span class="text-gray-300">|</span>
  <a [routerLink]="['/', selectedCountry?.code?.toLowerCase(), 'structures']" [ngClass]="{
      'text-primary': currentSection === 'structures',
      'text-gray-500': currentSection !== 'structures'
    }">Structures</a>
  <span class="text-gray-300">|</span>
  <a [routerLink]="['/', selectedCountry?.code?.toLowerCase(), 'pharmacies']" [ngClass]="{
      'text-primary': currentSection === 'pharmacies',
      'text-gray-500': currentSection !== 'pharmacies'
    }">Pharmacies</a>
</div>

<div class="container mt-8 !pb-10">
  <!-- Barre de recherche et filtres -->
  <app-search-and-filtrer (search)="onSearch()"></app-search-and-filtrer>

  <!-- Skeleton loading pour les cartes de pharmacies -->
  <div *ngIf="loading" class="space-y-4">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-7">
      <app-pharmacy-skeleton *ngFor="let item of [1,2,3,4,5,6]"></app-pharmacy-skeleton>
    </div>
  </div>

  <!-- Message d'erreur -->
  <div *ngIf="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
    {{ error }}
  </div>

  <!-- Liste des pharmacies -->
  <div *ngIf="!loading && pharmacies.length > 0">
    <div class="flex justify-between items-center mb-5 mt-2 opacity-50">
      <span class="text-[12px] text-gray-800">
        {{ totalItems }} pharmacie{{ totalItems > 1 ? "s" : "" }} trouvée{{
        totalItems > 1 ? "s" : ""
        }}
      </span>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <app-card-pharmacy *ngFor="let pharmacy of pharmacies" [pharmacy]="pharmacy"></app-card-pharmacy>
    </div>
    <!-- Pagination -->
    <div *ngIf="totalPages > 1" class="mt-8 flex justify-center">
      <nav class="flex items-center space-x-2">
        <button (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 1"
          class="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
          Précédent
        </button>
        <button *ngFor="let page of getPageNumbers()" (click)="onPageChange(page)" [class]="
            page === currentPage
              ? 'px-3 py-2 text-sm font-medium text-white bg-primary border border-primary rounded-md'
              : 'px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50'
          ">
          {{ page }}
        </button>
        <button (click)="onPageChange(currentPage + 1)" [disabled]="currentPage === totalPages"
          class="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
          Suivant
        </button>
      </nav>
    </div>
  </div>

  <!-- Message si aucune pharmacie trouvée -->
  <div *ngIf="!loading && pharmacies.length === 0" class="text-center py-12">
    <div class="text-gray-400 mb-4">
      <svg class="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    </div>
    <h3 class="text-lg font-medium text-gray-900 mb-2">
      Aucune pharmacie trouvée
    </h3>
    <p class="text-gray-500">Essayez de modifier vos critères de recherche.</p>
  </div>
</div>


